



































































import { Component, Vue } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import CharacterList from '@/components/parts/CharacterList.vue';
import MiniCharacterList from '@/components/parts/MiniCharacterList.vue';
import Map from '@/components/parts/Map.vue';
import MapLogList from '../parts/MapLogList.vue';
import KmyChatTagText from '../parts/KmyChatTagText.vue';
import * as api from './../../api/api';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';
import NotificationService from '@/services/notificationservice';

class HistoryData {
  public isLoading: boolean = false;
  public isLoaded: boolean = false;
  public monarch: api.Character;
  public warrior: api.Character;
  public grandGeneral: api.Character;
  private mIsOpen: boolean = false;

  public get label(): string {
    if (this.history.betaVersion) {
      return '第' + this.history.period + '.' + this.history.betaVersion + '期';
    }
    return '第' + this.history.period + '期';
  }

  public get unifiedCountry(): api.Country {
    const country = Enumerable
      .from(this.history.countries)
      .firstOrDefault((h) => !h.hasOverthrown);
    if (country) {
      return country;
    }
    return new api.Country(-1);
  }

  public get isOpen(): boolean {
    return this.mIsOpen;
  }

  public set isOpen(val: boolean) {
    if (this.mIsOpen !== val) {
      this.toggleOpen();
    }
  }

  public constructor(public history: api.History) {
    this.monarch = this.getMonarch();
    this.warrior = this.getWarrior();
    this.grandGeneral = this.getGrandGeneral();
    this.updateData();
  }

  private load() {
    this.isLoading = true;
    api.Api.getHistory(this.history.id)
      .then((h) => {
        this.history = h;
        this.updateData();
        this.isLoaded = true;
      })
      .catch(() => {
        NotificationService.historyLoadFailed.notify();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private getMonarch(): api.Character {
    return this.getPostCharacter(api.CountryPost.typeMonarch);
  }

  private getWarrior(): api.Character {
    return this.getPostCharacter(api.CountryPost.typeWarrior);
  }

  private getGrandGeneral(): api.Character {
    return this.getPostCharacter(api.CountryPost.typeGrandGeneral);
  }

  private getPostCharacter(pst: number): api.Character {
    const chara = Enumerable
      .from(this.history.characters)
      .firstOrDefault((c) => c.postType === pst);
    if (chara) {
      return chara;
    }
    return new api.Character(-1);
  }

  private updateData() {
    this.history.characters = Enumerable
      .from(this.history.characters)
      .where((c) => c.name.indexOf('_') < 0)
      .orderByDescending((c) => c.countryId)
      .toArray();
    this.history.characters.forEach((c) => {
      if (c.mainIcon) {
        c.mainIcon.isHistorical = true;
      }
    });
    this.history.countries.forEach((c) => {
      c.id = (c as any).countryId;
    });
    if (this.history.maplogs) {
      this.history.maplogs.forEach((m) => {
        m.isImportant = true;
      });
    }

    if (this.history.towns) {
      const unified = this.unifiedCountry;
      this.history.towns.forEach((t) => {
        t.countryId = unified.id;
      });
    }
  }

  private toggleOpen() {
    if (!this.mIsOpen) {
      if (!this.isLoaded && !this.isLoading) {
        this.load();
      }
      this.mIsOpen = true;
    } else {
      this.mIsOpen = false;
    }
  }
}

@Component({
  components: {
    CharacterList,
    CharacterIcon,
    MiniCharacterList,
    Map,
    MapLogList,
    KmyChatTagText,
  },
})
export default class UnifiedCountryPage extends Vue {
  public histories: HistoryData[] = [];
  private isLoading: boolean = true;

  private created() {
    api.Api.getHistories()
      .then((hs) => {
        this.histories = Enumerable
          .from(hs)
          .reverse()
          .select((i) => new HistoryData(i))
          .toArray();
      })
      .catch(() => {
        NotificationService.historyLoadFailed.notify();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
